import { Connection } from '../../connections/connection.class';
import { Island } from '../island.class';

/**
 * Rotates the island by changing the source connection's source panel to either the left (counter clockwise) or right panel (clockwise) panel.
 * @param island island to roate
 * @param clockwise boolean, true for clockwise, false for counter clockwise
 */
export const rotateIslandCfn = (island: Island, clockwise: boolean): void => {
	const sourceConnection = island.connections.getSourceConnections()[0] as Connection;
	const sourcePanelId = clockwise
		? sourceConnection.sourcePanel.connections.right.targetPanelId
		: sourceConnection.sourcePanel.connections.left.targetPanelId;

	const { targetPanel, targetIsland } = sourceConnection;
	const sourcePanel = island.panels.findById(sourcePanelId);
	const sourceAngle = (sourcePanel.getOriginAngle() - targetPanel.getOriginAngle() + 180 + targetIsland.axis.y) % 360;
	island.axis.y = sourceAngle;

	sourceConnection.sourcePanelId = sourcePanelId;
};
